import { useCallback, useState } from 'react';
import type { Mention } from '../../hooks';
import type { CommentMention } from '../../containers/CommentList/CommentList.types';
import { mergeMentionsByRange } from './mergeMentions';
import { toCommentMentions } from './mapMentions';

export function useProcessedMentions(
  initialParsedMentions: Mention[],
  onMentionsChange?: (mentions: CommentMention[]) => void
) {
  const [mentions, setMentions] = useState<Mention[]>([]);

  const handleMentionsChange = useCallback(
    (newMentions: Mention[]) => {
      const merged = mergeMentionsByRange(newMentions, initialParsedMentions);
      setMentions(merged);
      if (onMentionsChange) {
        onMentionsChange(toCommentMentions(merged));
      }
    },
    [initialParsedMentions, onMentionsChange]
  );

  return { mentions, handleMentionsChange } as const;
}
